module.exports = __webpack_public_path__ + "static/img/loading-gif.25edaced.svg";